/**
 * The one address the legal apps card and its stand-in link to: the Integrations page's legal apps view (legal apps
 * deliveries 2a and 3). The chat opens it in place (INTERNAL_MANAGE_ANCHOR_HREF_RE admits it).
 *
 * A leaf on purpose: the chat engine's stand-in (legalAppsCard.ts) and the card's rows in the legal-apps download
 * (LegalAppsTile.tsx) both read it, and importing either file from the other would copy it into the other's download.
 */
export const LEGAL_APPS_PAGE_HREF = '/integrations?category=legal';
